import script from "./GenericUppyUploader.vue?vue&type=script&setup=true&lang=ts"
export * from "./GenericUppyUploader.vue?vue&type=script&setup=true&lang=ts"

import "./GenericUppyUploader.vue?vue&type=style&index=0&id=63eb51d7&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63eb51d7"]])

export default __exports__